import React, { useCallback } from 'react';
import { useHotkeys } from '@mantine/hooks';
import { useTraceableProjectState, getSharedData, getProjectState } from '@starflow/app/store';
import { getElementTools } from '@starflow/app/extension/elements';

// 撤销重做快捷键处理在这里

const shouldPrevent = () => {
  const preventUndoRedo = getSharedData('preventUndoRedo');

  if (preventUndoRedo) {
    return true;
  }

  const currentElementTool = getProjectState('currentElementTool');

  if (currentElementTool) {
    const toolConfig = getElementTools().find((tool) => tool.name === currentElementTool);

    if (toolConfig?.preventCanvasUndoRedo) {
      return true;
    }
  }

  return false;
};

export const UndoRedo = React.memo(() => {
  const { undo, redo, pastStates, futureStates } = useTraceableProjectState();

  const canUndo = pastStates.length > 1;
  const canRedo = futureStates.length > 0;

  const handleUndo = useCallback(
    (event) => {
      if (shouldPrevent()) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!canUndo) return;
      undo();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [canUndo],
  );

  const handleRedo = useCallback(
    (event) => {
      if (shouldPrevent()) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!canRedo) return;
      redo();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [canRedo],
  );

  useHotkeys(
    [
      ['mod + z', handleUndo],
      ['shift + mod + z', handleRedo],
    ],
    ['INPUT', 'TEXTAREA'],
  );

  return null;
});
